export const MessageConstants = {

  //Common message
  EMPTY_FIELD_MESSAGE: 'All fields are mandatory',
  DOCUMENT_UPLOADED: 'Document uploaded successfully',
  UPLOAD_DOCUMENT: 'Please upload', //Document name will be append at the end
  OTP_SENT_MESSAGE: 'OTP has been sent',
  UPLOAD_FRONT_PAGE: 'Please upload front page',
  UPLOAD_BACK_PAGE: 'Please upload back page',
  DOCUMENT_SIGNING_FAILED_MESSAGE: 'We could not sign the Document. Please try again after sometime',
  SELECT_DOCUMENT_TYPE: 'Please select Document Type',
  DOCUMENT_NUMBER_ERROR: 'Please enter Document number',
  APPLICANT_TYPE_ERROR: 'Please select Applicant type',

  //Config Data
  CONFIG_DATA_INVALID: 'Config data is not valid - Please contact EzCred Support',

  //Address Activity
  SELECT_STATE_MESSAGE: 'Please select State',
  INVALID_POSTAL_CODE_MESSAGE: 'Pin code must be length of six',
  INVALID_STREET_ADDRESS_MESSAGE: 'At least 2 words with 2 letter needed for Flat/HouseNo./Floor/Building',
  SELECT_ADDRESS_OWNERSHIP_TYPE_MESSAGE: 'Please select ownership type',

  //Bank Details Activity
  SELECT_ACCOUNT_TYPE_MESSAGE: 'Please select Account Type',
  SELECT_BANKING_TYPE_MESSAGE: 'Please select Banking Type',
  INVALID_NO_OF_YEARS_MESSAGE: 'Please enter valid number of years',
  INVALID_IFSC_CODE_MESSAGE: 'Please enter valid IFSC code',
  INVALID_ACCOUNT_NUMBER_MESSAGE: 'Please enter valid Account Number',

  //Bank Details Verification Activity
  NAME_OPTION_NOT_SELECTED_MESSAGE: 'Please select the correct option',
  EMPTY_CUSTOMER_NAME_MESSAGE: 'Please provide Customer Name',

  //Bank Statement Activity
  DOCUMENT_OPTIONS_NOT_SELECTED: 'Please select an option to continue',
  ENTER_FILE_PASSWORD: 'Please enter file password.',

  //Choose Emi Activity
  EMI_SCHEMES_NOT_AVAILABLE_MESSAGE: 'There are no EMI schemes available',
  SELECT_CHOOSE_EMI_DATE_MESSAGE: 'Please select EMI repayment date for each month',

  //Client Details Activity
  INVALID_PAN_NUMBER_MESSAGE: 'Please enter valid PAN number',
  EMPTY_NAME_MESSAGE: 'Please enter valid Name',
  EMPTY_DATE_OF_BIRTH_MESSAGE: 'Please enter valid Date of Birth',
  MINIMUM_AGE_MESSAGE: 'Minimum allowed age is 18 years.',
  SELECT_GENDER_MESSAGE: 'Please select the gender',
  TERMS_AND_CONDITION_MESSAGE: 'Please agree to all T&Cs to progress forward',

  //Digio Esign Activity
  SIGN_IN_COMPLETED_SUCCESSFULLY_MESSAGE: 'The Document has been signed successfully',

  //Kyc Activity
  SELECT_KYC_OPTION_MESSAGE: 'Please select correct option for KYC',
  SCAN_AADHAAR_NOT_SUPPORTED_MESSAGE: 'We could not scan the Aadhaar code - Please contact EzCred Support',
  UPLOAD_ADDRESS_PROOF_MESSAGE: 'Please upload Address Proof Document',

  //Login Activity
  INVALID_PHONE_NUMBER_MESSAGE: 'Please enter valid Phone Number',
  INVALID_OTP_MESSAGE: 'Please enter valid OTP',
  ENTER_USERNAME: 'Please enter Username.',
  ENTER_PASSWORD: 'Please enter Password',

  //Personal Details Activity
  SELECT_MARITAL_STATUS_MESSAGE: 'Please select Marital Status',
  SELECT_ADDRESS_OWNERSHIP_MESSAGE: 'Please select Address Ownership Type',
  INVALID_EMAIL_MESSAGE: 'Please enter valid Email',
  INVALID_NO_OF_DEPENDENTS_MESSAGE: 'Please enter valid number of dependents',

  //Professional Details Activity
  SELECT_PROFESSION_MESSAGE: 'Please select Profession',
  EMPTY_DECLARED_INCOME_MESSAGE: 'Please enter your declared Income',
  EMPTY_SALARY_MESSAGE: 'Please enter your Salary',

  //Additional Professional Details Activity
  INVALID_MONTHS_MESSAGE: 'Please enter valid no of Months',
  SELECT_EDUCATIONAL_LEVEL_MESSAGE: 'Please select Education Level',
  SELECT_COMPANY_TYPE_MESSAGE: 'Please select Company Type',
  INVALID_NO_OF_MONTHS_MESSAGE: 'Please enter valid no of Months',
  INVALID_EXPERIENCE_MESSAGE: 'Please enter valid Job Experience Information - Number of Years in current job cannot be more than Total Years of Experience',

  //ClientIdentifiersCheckDialog
  VALID_DATA_MESSAGE: 'Please enter valid data',

  //Nach Form Activity
  FILLED_NACH_NOT_FOUND: 'We are not able to locate generated NACH/Mandate Form - Please contact EzCred Support',
  UPLOAD_NACH_FORM: 'Please upload NACH/Mandate Form',
  NACH_UPLOADED: 'NACH/Mandate Form has been uploaded successfully',
  DOWNLOADING_NACH_FORM: 'Downloading NACH/Mandate Form',
  RETRY_NACH_FORM_DOWNLOAD: 'Not able to download NACH/Mandate Form - Please try again.',
  NACH_FORM_DOWNLOADED: 'NACH/Mandate Form has been downloaded successfully',

  //Contact support email dialog
  ENTER_SUBJECT: 'Please enter Subject',
  ENTER_DESCRIPTION: 'Please enter body of the Email text',
  EMAIL_SENT: 'Email sent successfully',
  EMAIL_NOT_SENT: 'Email could not be sent',
  SESSION_EXPIRED_LOGIN_TO_CONTINUE: 'Session expired, please login to continue.',

  //Product price item view
  SELECT_CATEGORY: 'Please select category.',
  SELECT_BRAND: 'Please select brand.',
  SELECT_MODEL: 'Please select model.',
  ENTER_PRICE: 'Please enter price.',
  ENTER_VALID_PRICE: 'Please enter valid price.',
  DETAILS_NOT_VALID: 'Entered details are not valid.',

  //Select Center
  SELECT_CENTER: 'Please select Coaching Center',

  //T&C
  MANUAL_SIGN_OPTION_NOT_SUPPORTED: 'We do not support Manual signature on the documents',
  NO_SIGN_MODE_PRESENT: 'There are no modes to support signature on the documents - Please contact EzCred Support',
  CHOOSE_SIGN_MODE_OPTION: 'Please select a valid way to Sign Documents',
  INVALID_LENDER_AGREEMENT_OTP : "OTP verification failed, Please retry or contact support",

  //Downpayment
  DELIVERY_ADVICE_NOT_FOUND: 'Delivery Advice not found',
  UPLOAD_INVOICE_DETAILS: 'Please upload Invoice details',
  INVOICE_DETAILS_UPLOADED: 'Invoice details uploaded',
  CHECK_IF_NAME_AND_PAN_CORRECT: 'Please check if Name and PAN number are correct.',
  PAYMENT_IS_NOT_DONE: "Please complete the payment",
  PAN_IS_NOT_VALID: 'PAN number is not valid.',
  PAYMENT_SUCCESSFUL: "Payment completed successfully.",
  PAYMENT_FAILED: "Payment failed.",
  TRY_LATER: "Please try after sometime.",

  SELECT_OPTION_TO_CONTINUE: "Please select an option to continue.",
  SELECTED_OPTION_NOT_SUPPORTED: "Selected option is not supported.",

  //Form 60
  DATE_OF_APPLICATION_ERROR : "Please Select Date Of Application",
  ACKNOWLEDGEMENT_NUMBER_ERROR : "Please Enter Acknowledgement Number",
  FUTURE_DATE_OF_APPLICATION_ERROR : "Date of application cannot be in future.",
  AGRI_INCOME_ERROR : "Please Enter Agricultural Income",

  //Reset Password 
  SAME_PASSWORD : "Password and Repeat password should be same",
  INVALID_PASSWORD : "Password must be at least 6 characters, no more than 50 characters long, must include at least one upper case letter, one lower case letter, one numeric digit and no space.",

};

export const StudentDetailsMessage = {
  ENTER_STUDENT_DETAILS: 'Please enter the Student Details',
  EMPTY_FIELD_MESSAGE: 'All fields are mandatory',
  ENTER_VALID_NAME: 'Please enter valid Name',
  SELECT_GENDER: 'Select Gender',
  ENTER_STUDENT_BOARD: 'Please enter Student’s Board',
  ENTER_STUDENT_RELATION: 'Please enter valid Student’s Relation with Applicant',
  ENTER_STUDENT_CLASS: 'Please enter Student’s Class',
  ENTER_STUDENT_COURSE: 'Please enter Product Name/Course',
  ENTER_STUDENT_APPLICATION_NO: 'Please enter Student’s Application Number',
}

export const LoanApprovedAmountMessage = {
  ENTER_AMOUNT: "Please enter Amount",
  ENTER_VALID_AMOUNT: "Please enter valid Amount",
  AMOUNT_CANNOT_MORE_THAN_APPROVED: "Amount cannot be more than approved amount.",
  AMOUNT_CANNOT_LESS_THAN_MINIMUM: "Amount not acceptable. Please provide correct value or Choose the option to Decline and reject loan application.",
}
